import { render } from "./settings_assignment_modal.html?vue&type=template&id=15685182&external"
import script from "./settings_assignment_modal.js?vue&type=script&lang=js&external"
export * from "./settings_assignment_modal.js?vue&type=script&lang=js&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__